import { createResourceModule } from '../../../lib/resource/module.js';
import { roomTypeDetail } from './schemas.js';

/**
 * The Room Types module's API layer.
 *
 * The six CRUD paths come from the shared factory. Property options live in
 * the Properties module's endpoint, but the dropdown is shared through the
 * `PropertySelect` component and does not need its own option lookup here.
 */
export const roomTypes = createResourceModule({
  resource: 'roomTypes',
  basePath: '/v1/room-types',
  detail: roomTypeDetail,
});

export const roomTypeEndpoints = roomTypes.endpoints;

export const roomTypeAmenitiesEndpoints = {
  get: (roomTypeId: string): string => `/v1/room-types/${encodeURIComponent(roomTypeId)}/amenities`,
  update: (roomTypeId: string): string =>
    `/v1/room-types/${encodeURIComponent(roomTypeId)}/amenities`,
} as const;
